import api from "./api-utils";

export const getFleetStatus = async () => {
  try {
    const response = await api.get("/api/assets/fleet-status");
    return response.data;
  } catch (err) {
    // Tenants with zero assets return 404 from fleet-status; treat as empty fleet
    // so the tenant switch and downstream UI can render normally.
    if (err?.response?.status === 404) {
      return { Assets: [] };
    }
    throw err;
  }
};

export const getNoDataStats = async (fromDate, toDate, assetId) => {
  const body = {
    FromDate: fromDate,
    ToDate: toDate,
  };
  if (assetId != null && assetId !== "") {
    body.AssetId = Number(assetId);
  }
  try {
    const response = await api.post("/api/assets/no-data-stats", body);
    return response.data;
  } catch (err) {
    // Asset-scoped requests return 404 when the asset has no stats in the window;
    // treat as empty so Asset Vitals renders without a no-data stats error.
    if (assetId != null && assetId !== "" && err?.response?.status === 404) {
      return [];
    }
    throw err;
  }
};
